<div class="container">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="!isFormValid">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="showSuccessMsg">
        <div class="col-24">
            <div class="alert success">
                <p>{{errorConfMsg}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="instructions-list">
                <p><strong>Change user password: Password must contain:</strong></p>
                <ul>
                    <li>Be a minimum length of 12 characters</li>
                    <li>at least 1 upper-case letter</li>
                    <li>at least 1 lower-case letter</li>
                    <li>at least 1 number</li>
                    <li>At least one special character</li>
                </ul>
            </div>
        </div>
    </div>

    <fieldset>
        <legend>Login ID: {{userProfileName}}</legend>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField (onValueChange)="userPassword = $event"
                                        label="Current Password"
                                        fieldId="userPassword"
                                        [text]="userPassword"
                                        type="password"
                                        [validators]="[notBlankValidator, passwordCorrectCountValidator]">
                    </ValidatedTextField>
                    <label *ngIf="!isOldPasswordCorrect">{{oldPasswordErrorMsg}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ConfirmProfileSetPassword [password]="passwordResetModel.newPassword"
                                               [passwordConfirmation]="passwordResetModel.confirmPassword"
                                               (onPasswordChange)="passwordResetModel.newPassword = $event"
                                               (onPasswordConfirmChange)="passwordResetModel.confirmPassword = $event">
                    </ConfirmProfileSetPassword>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <h2 class="head2-small">Please select a security question, in the event that you misplace your password</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedDropDown class="wide"
                                       [label]="'Please select a security question, in the event that you misplace your password'"
                                       [disabled]="false"
                                       [options]="questionOptions"
                                       [selectedValue]="securityQuestion"
                                       (change)="onQuestionChange($event.target.value)">
                    </ValidatedDropDown>
                </div>
            </div>
            <!--<select (change)="onChange($event.target.value)">
                <option disabled hidden [value]="selectUndefinedOptionValue">Select a Challenge Question</option>
                <option value={{i.QuestionID}} *ngFor="let i of securityQuestions">{{i.Question}}</option>
            </select>-->
            <div class="col-16">
                <div class="input-wrapper">
                    <input type="text" id="securityAnswer" (blur)="securityAnswer=$event.target.value" placeholder="Enter Answer" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="Save()">Save</button>
                <button class="button cancel" (click)="cancel()">{{CloseBtnText}}</button>
            </div>
        </div>
    </fieldset>
</div>



